<script setup lang="ts">
const props = defineProps({
  desktop: {
    type: Boolean,
    required: true,
  },
});
const { data: session } = useAuth();
const isNative = useIsNativePlatform();
const admin = () => {
  if (session.value?.roles.includes('ROLE_SUPER_ADMIN')) {
    useRouter().push('/admin');
  }
};
const isAdminArea = computed(() => useRouter().currentRoute.value.path.startsWith('/admin'));
const wrapper = computed(() => (isAdminArea.value ? 'div' : resolveComponent('UContainer')));
const wrapperClass = computed(() => (isAdminArea.value ? 'px-4 w-full' : ''));
const showLoginAndSignUpLinks = computed(() => {
  return !session.value && !useRouter().currentRoute.value.path.startsWith('/login') && !useRouter().currentRoute.value.path.startsWith('/signup');
});
const showLanguageSwitch = computed(() => {
  return !session.value;
});
</script>
<template>
  <component :is="wrapper" :class="wrapperClass">
    <div>
      <div class="flex justify-between p-4 pb-0">
        <NuxtLink to="/">
          <h1 class="top-0 mb-0">
            <IconLogoWordmark class="text-4xl md:text-5xl lg:text-6xl" />
          </h1>
          <h2 class="inline-block font-bold text-gray-500 dark:text-white pb-4 mt-2"><TextBrand text="Next Level" /> Location Performance.<br /></h2>
        </NuxtLink>
        <div v-if="showLanguageSwitch || showLoginAndSignUpLinks" class="text-end">
          <LanguageSwitch v-if="showLanguageSwitch" />
          <div v-if="showLoginAndSignUpLinks" class="text-end">
            <UButton to="/login" variant="ghost" :label="$t('button.login')" />
            <UButton v-if="!isNative" to="/signup" variant="ghost" :label="$t('button.signUp')" />
          </div>
        </div>
        <div v-if="session" class="flex items-center gap-2">
          <div v-if="props.desktop" class="grid text-sm justify-items-end overflow-y-auto">
            <div class="flex flex-col justify-items-end">
              <TextBrand
                class="text-right shrink text-2xl truncate w-32 md:w-64"
                :title="$t('header.externalId', { externalId: session.organization.customerNumber })"
                :text="session.organization.name"
                @click="admin()"
              />
              <div class="text-right w-32 md:w-64 truncate text-muted whitespace-nowrap">{{ session.firstname }} {{ session.lastname }}</div>
            </div>
            <div class="flex items-center gap-6 mt-4">
              <AppCartIndicator />
              <AppPermanentMessagesIndicator />
            </div>
          </div>
        </div>
      </div>
    </div>
    <USeparator />
  </component>
</template>
